import { CompanyWebFigureTile } from "@/components/company/company-web-figures";
import {
  KEY_FIGURE_IDS,
  webFigureOf,
  type KeyFigureId,
  type TagPlace,
} from "@/lib/company-web-figures";
import type { CompanyWebKeyData } from "@shaarp/common";
import type { ReactNode } from "react";

/**
 * A tile for each key figure the web states, for a company in base to show
 * where its own figure is missing: no placeholder, no "Not found".
 */
export function webFigureTiles(
  keyData: Partial<CompanyWebKeyData>,
  tag: TagPlace | null | undefined,
  isWriting: boolean,
): Partial<Record<KeyFigureId, ReactNode>> {
  return Object.fromEntries(
    KEY_FIGURE_IDS.filter((id) => webFigureOf(id, keyData, tag)).map((id) => [
      id,
      <CompanyWebFigureTile
        id={id}
        keyData={keyData}
        tag={tag}
        isWriting={isWriting}
      />,
    ]),
  );
}
